import React from 'react'
import { Col, Row } from 'reactstrap'
import DateDisplay from 'src/components/DateDisplay'
import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { yesno } from 'src/helpers/displayhelpers'
import { StaffingAgencyMsaById } from 'src/queries'

interface ListProps {
  agency: StaffingAgencyMsaById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { agency } = props
  const msa = agency?.staffingAgency?.msa ?? {}

  const section1: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Date MSA Signed',
      value: (
        <DateDisplay date={msa.dateSigned} display='dateOnly' />
      )
    },
    { title: 'Conversion Timeframe', value: msa.conversionTimeframe },
    { title: 'Conversion Fees', value: msa.conversionFees },
    { title: 'DH Available', value: yesno(msa.dhAvailable ?? undefined) },
    { title: 'Warranty on DH', value: msa.dhWarranty },
    { title: 'Non-Solicitation Duration', value: msa.nonSolicitationDuration }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: agency === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <Row>
      <Col>
        <DescriptionList {...dlProps}>
          {section1.map(item => {
            const key = item.title.toLowerCase().replace(' ', '-')
            return <Item {...item} key={key} id={key} />
          })}
        </DescriptionList>
      </Col>
    </Row>
  )
}

export default List
